import { render, staticRenderFns } from "./api-doc.vue?vue&type=template&id=75b81d2e"
import script from "./api-doc.vue?vue&type=script&lang=js"
export * from "./api-doc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports